import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">{siteInfo.name}</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h5 className="font-heading text-base text-background-50 mb-4">分类导航</h5>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="font-heading text-base text-background-50 mb-4">热门文章</h5>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/shiroi-socks-jk-shouban-top10" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  白丝JK手办TOP10
                </Link>
              </li>
              <li>
                <Link to="/article/jk-uniform-white-socks-guide" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  JK制服搭配指南
                </Link>
              </li>
              <li>
                <Link to="/article/genuine-vs-fake-identification" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  正版鉴别技巧
                </Link>
              </li>
              <li>
                <Link to="/article/white-socks-jk-beginner-guide" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                  新人入坑攻略
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="font-heading text-base text-background-50 mb-4">联系方式</h5>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                <span>{siteInfo.wechat}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line"></i>
                <span>{siteInfo.weibo}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} {siteInfo.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <Link to="/about" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer">关于我们</Link>
            <Link to="/" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer">首页</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}